module.exports = __webpack_public_path__ + "static/media/companyLawyer-Wed_11.5b8611b9.jpg";